import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function ChevronSVG({ classNameProps, height, width }: PropsTypeSvg) {
  return (
    <svg
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.5607 4.93934C19.9749 4.35355 19.0251 4.35355 18.4393 4.93934L8.37864 15L18.4393 25.0607C19.0251 25.6465 19.9749 25.6465 20.5607 25.0607C21.1464 24.4749 21.1464 23.5252 20.5607 22.9394L12.6213 15L20.5607 7.06066C21.1464 6.47487 21.1464 5.52513 20.5607 4.93934Z'
      />
    </svg>
  );
}

export default ChevronSVG;
